import USPs from "components/USPs";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="hero__inner container">
          {/* Colonne gauche : contenu sur fond blanc */}
          <div className="hero__content">
            <h1>The TresorSafe</h1>
            <p className="hero__lead">
              Marque dédiée aux armoires à fusils sécurisées. Découvrez notre
              gamme et nos revendeurs agréés.
            </p>

            <div className="hero__cta">
              <Link to="/produits" className="btn">
                Voir les produits
              </Link>
              <Link
                to="/revendeurs"
                className="btn btn-secondary btn-ghost"
                aria-label="Trouver un revendeur"
              >
                Trouver un revendeur
              </Link>
            </div>

            <div className="hero__subcta">
              <Link className="btn btn-ghost" to="/contact">
                Devenez revendeur&nbsp;!
              </Link>
            </div>
          </div>

          {/* Colonne droite : image produit */}
          <div className="hero__media" aria-hidden="true">
            <picture>
              <source srcSet="/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp" type="image/webp" />
              <img
                className="hero__product"
                src="/assets/tresorsafe-hero.jpg"
                alt=""
                loading="eager"
                decoding="async"
                width={520}
                height={520}
              />
            </picture>
          </div>
        </div>
      </section>

      {/* USPs */}
      <USPs />
    </>
  );
}